import React from 'react'
import PropTypes from 'prop-types'

const BigRadioButton = ({ selected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={selected ? 'cls-ld-big-radio-button selected' : 'cls-ld-big-radio-button'}
    >
      {selected && (
        <svg className={'selected-dot'} viewBox="0 0 32 32">
          <circle cx="16" cy="16" r="14"/>
        </svg>
      )}
    </div>
  )
}

BigRadioButton.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default BigRadioButton
